<template>
    <div class="shop-search-bar">
        <div class="shop-search-bar--body">
            <input type="text" placeholder="Titul, kategória alebo autor" v-model="search">

            <span v-if="search" class="delete-text" @click="search = ''">
                <svg viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M4 4L8 8L4 12" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                    <path d="M12 4L8 8L12 12" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                </svg>
            </span>
        </div>

        <div v-if="results" class="shop-search-bar--results">
            <ul v-if="results.products.length" class="shop-search-bar--results--list">
                <li class="shop-search-bar--results--list--item" v-for="product in results.products" :key="product.id">
                    <ShopSearchProduct :product="product" />
                </li>
            </ul>

            <div v-if="results.categories.length" class="shop-search-bar--results--head">
                Kategórie
            </div>

            <ul v-if="results.categories.length" class="shop-search-bar--results--list">
                <li class="shop-search-bar--results--list--item" v-for="category in results.categories" :key="category.id">
                    <a :href="category.url">
                        <div>{{ category.name }}</div>
                    </a>
                </li>
            </ul>

            <div v-if="results.authors.length" class="shop-search-bar--results--head">
                Autori
            </div>

            <ul v-if="results.authors.length" class="shop-search-bar--results--list">
                <li class="shop-search-bar--results--list--item" v-for="author in results.authors" :key="author.id">
                    <a :href="author.url">
                        <div>{{ author.name }}</div>
                    </a>
                </li>
            </ul>

            <ul v-if="!results.products.length && !results.categories.length && !results.authors.length" class="shop-search-bar--results--list">
                <li class="shop-search-bar--results--list--item">
                    <span class="center">Ľutujeme, nič sme nenašli...</span>
                </li>
            </ul>
        </div>
    </div>
</template>

<script>
    import ShopSearchProduct from './ShopSearchProduct'

    export default {
        components: {
            ShopSearchProduct
        },
        data() {
            return {
                search: '',
                results: null
            }
        },
        mounted() {
            const accountIcon = document.getElementById('header-account-icon-wrapper')

            if ( accountIcon ) accountIcon.addEventListener('mouseover', this.handleMouseOver)
        },
        beforeDestroy() {
            const accountIcon = document.getElementById('header-account-icon-wrapper')

            if ( accountIcon ) accountIcon.removeEventListener('mouseover', this.handleMouseOver)
        },
        methods: {
            startSearch() {
                axios.post('/api/shop/search/header-search', { search: this.search })
                .then( response => { 
                    this.results = response.data.results 
                })
                .catch( errors => { alert('Woops, nepodarilo sa načítať dáta!') })
            },
            handleMouseOver() {
                this.search = ''
                this.results = null
            }
        },
        watch: {
            'search': {
                handler: function () {
                    if ( this.search.length > 3 ) {

                        if ( this.timer ) {
                            clearTimeout( this.timer )
                            this.timer = null
                        }
    
                        this.timer = setTimeout(() => {
    
                            this.startSearch()
    
                        }, 500)

                    } else {

                        this.results = null

                    }
                },
                deep: true
            },
        }
    }
</script>